import { ServiceResult } from '../models';
import {
  CreateRecipeCategoryRequest,
  DeleteRecipeCategoryRequest,
  RecipeCategory,
  UpdateRecipeCategoryRequest,
} from '../models/recipe-category.models';
import ApiService from './api-service';

class RecipeCategoryService extends ApiService {
  private static classInstance: RecipeCategoryService;

  private constructor() {
    super('RecipeCategory');
  }

  public static getInstance(): RecipeCategoryService {
    if (!this.classInstance) {
      this.classInstance = new RecipeCategoryService();
    }
    return this.classInstance;
  }

  public getRecipeCategory(recipeCategoryId: string, viewAsCustomerId: string): ServiceResult<RecipeCategory> {
    return this.get(
      `${this.baseUrl}/GetRecipeCategory?recipeCategoryId=${recipeCategoryId}&viewAsCustomerId=${viewAsCustomerId}`
    );
  }

  public getRecipeCategorys(customerId: string): ServiceResult<RecipeCategory[]> {
    return this.get(`${this.baseUrl}/GetRecipeCategorys?customerId=${customerId}`);
  }

  public createRecipeCategory(request: CreateRecipeCategoryRequest): ServiceResult<RecipeCategory> {
    return this.post(`${this.baseUrl}/CreateRecipeCategory`, request);
  }

  public updateRecipeCategory(request: UpdateRecipeCategoryRequest): ServiceResult<RecipeCategory> {
    return this.post(`${this.baseUrl}/UpdateRecipeCategory`, request);
  }

  public deleteRecipeCategory(request: DeleteRecipeCategoryRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/DeleteRecipeCategory`, request);
  }
}

export default RecipeCategoryService;
